import { useState, type AnimationEvent } from 'react'
import styled, { css, keyframes } from 'styled-components'
import useGlobalModal from 'hooks/useGlobalModal'
import SharePanel from 'page/SharePage/component/SharePanel'

/** 與 app-layered-layout 換頁一致：AppLayout 的 ANIMATION_DURATION（350ms）、線性 translateX */
const SLIDE_DURATION_MS = 350

/**
 * 全屏分享彈窗：內容同 /share 頁，但不 push 路由。
 * 從 /watch、瀑布流分享時改開這個，避免頁面堆疊中推入 /share 後返回異常。
 * 走 GlobalModal 槽；「保存圖片分享」的 ShareCard 走 HintModal 槽，後開者會疊在上層。
 * 進出場比照換頁的 overlay 動畫：從右側滑入，關閉時滑出右側後才真正關閉彈窗。
 */
export default function ShareModal() {
  const { closeGlobalModal } = useGlobalModal()
  const [leaving, setLeaving] = useState(false)

  const handleAnimationEnd = (e: AnimationEvent<HTMLDivElement>) => {
    // animationend 會冒泡，只認自己的滑出動畫，避免子元素（loading 等）動畫結束誤關
    if (leaving && e.target === e.currentTarget) closeGlobalModal()
  }

  return (
    <FullScreen $leaving={leaving} onAnimationEnd={handleAnimationEnd}>
      <SharePanel active onClose={() => setLeaving(true)} />
    </FullScreen>
  )
}

const slideIn = keyframes`
  from { transform: translateX(100%); }
  to { transform: translateX(0); }
`

const slideOut = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(100%); }
`

// GlobalModal 的 content 以 translate(-50%, -50%) 置中，這裡撐滿視窗即為全屏
const FullScreen = styled.div<{ $leaving: boolean }>`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background: var(--main-background);
  animation: ${slideIn} ${SLIDE_DURATION_MS / 1000}s linear both;
  ${(p) =>
    p.$leaving &&
    css`
      animation: ${slideOut} ${SLIDE_DURATION_MS / 1000}s linear both;
      pointer-events: none;
    `}
`
